import Vue from 'vue';
import Notifications from 'vue-notification';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import TranslateService from '@/services/TranslateService';

Vue.config.productionTip = false;

Vue.use(Notifications);
Vue.use(VueI18n);

const appUrl = new URL(window.location.href);
const definedLang = appUrl.searchParams.get('lang');

TranslateService.getAll(definedLang).then(i18n => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
});
